import React from 'react';
import Offer from "./Offer";
import ReactPaginate from 'react-paginate';

const OffersList = ({ source, country, city, department, category, perPage, paginate, currentPage }) => {

    if (undefined === source.offers) {
        return null;
    }

    let offers = source.offers;

    const setOffers = () => {
        offers = source.offers.filter(offer => (
            (country === 0 || country === offer.country) &&
            (city === 0 || city === offer.city) &&
            (department === 0 || department === '0' || department === offer.department) &&
            (category === 0 || category === '0' || category === offer.category)
        ))
    }

    setOffers();

    const indexOfLastOffer = currentPage * perPage;
    const indexOfFirstOffer = indexOfLastOffer - perPage;
    const currentOffers = offers.slice(indexOfFirstOffer, indexOfLastOffer);
    const pageCount = Math.ceil(offers.length / perPage);
    const emptyLink = document.getElementById('offers_list').dataset.empty_link;

    if (currentOffers.length === 0) {
        return <div>
            <h3 className={'noOffers'}>At the moment we do not have job offers in this area however we want to stay in touch with you, so <a href={emptyLink} target={'_blank'} rel={"noopener noreferrer"}>leave us your CV.</a></h3>
        </div>
    }

    return (
        <div className="cr_offers">
            <table page_number="1" className="cr_offers_tb" sort_column="cr_col_publish_date" sort_order="desc">
                <thead>
                <tr>
                    <th>Job position</th>
                    <th>City</th>
                    <th>Business Unit</th>
                    <th></th>
                </tr>
                </thead>
                <tbody className="cr_offers_tbody">
                {currentOffers.map(offer => (
                    <Offer offer={offer} key={offer.id} />
                ))}
                </tbody>
            </table>

            <ReactPaginate
                previousLabel={'◀'}
                nextLabel={'▶'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={paginate}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
            />
        </div>
    );
};

export default OffersList;
